(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[739],{

/***/ 12824:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gift-card",
      function () {
        return __webpack_require__(69956);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94038:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/gift-banner.791bc136.jpg","height":430,"width":1900,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAACAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAZEAEAAwEBAAAAAAAAAAAAAAABAAIDEUL/xAAVAQEBAAAAAAAAAAAAAAAAAAADBv/EABYRAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEQMRAD8An1ttSqGtw4emIiHVLp//2Q=="});

/***/ }),

/***/ 69956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ gift_card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 6 modules
var Modal = __webpack_require__(6212);
// EXTERNAL MODULE: ./src/layout/layout.tsx + 22 modules
var layout = __webpack_require__(16559);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/assets/images/gift-banner.jpg
var gift_banner = __webpack_require__(94038);
;// CONCATENATED MODULE: ./src/assets/images/gift-card-bg-premium.png
/* harmony default export */ var gift_card_bg_premium = ({"src":"/_next/static/media/gift-card-bg-premium.3edb8788.png","height":1024,"width":1024,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAANlBMVEVyNjBPCxNWGxpCBw66hG9yLShiIx97RDifW0qWZFEvBgh6Tz6ub1evcl6VRDvPrJTPl32zemH77HWqAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAOUlEQVR4nAXBhwHAMAzDMMo76f7/2QK4l6g0XLIV30FZ3m+sZs6JVDe9IvspY2rgWpsMkDB0YK69fzL/AV4ui62VAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/assets/images/gift-card-defult.png
/* harmony default export */ var gift_card_defult = ({"src":"/_next/static/media/gift-card-defult.7c1881cc.png","height":498,"width":498,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEWWEhN2DAyLCgywGhu/FxupExbAKSnWOjaiOy+QQTGgJyW+Oze5VUGHGxisQzeMfGmqAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAO0lEQVR4nBXKSRIAIQgEwW6QTWX+/9yRW0VGQaBLDYKJZcCEu4LgPhFn84lH+IjYe4SoynszC+z+Es0fIYMBNLXF0YsAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/assets/images/logo-pop-new.png
var logo_pop_new = __webpack_require__(47441);
;// CONCATENATED MODULE: ./src/assets/images/Anniversary.svg
/* harmony default export */ var Anniversary = ({"src":"/_next/static/media/Anniversary.6e88b8de.svg","height":40,"width":40});
;// CONCATENATED MODULE: ./src/assets/images/diamond-ring.svg
/* harmony default export */ var diamond_ring = ({"src":"/_next/static/media/diamond-ring.e9634c0e.svg","height":42,"width":34});
;// CONCATENATED MODULE: ./src/assets/images/giftbannermobile.png
/* harmony default export */ var giftbannermobile = ({"src":"/_next/static/media/giftbannermobile.9eb2a3b0.png","height":400,"width":400,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEVMAhiULEavaFdtFStZBR9kDCaHIzx2JzZ5GjRwLyqXQEugNVBaEx6lVkiSRTq7ujafAAAAA3RSTlP+/v6VFoksAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVR4nB3GSRLAIAwDMKfOHuD/z4WpToLsr2dGcLY87jju3Z4JMiOShJkxaISqRZkSeFWthd8qXDfpAV2SVh2IAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/assets/images/others.svg
/* harmony default export */ var others = ({"src":"/_next/static/media/others.5b54019c.svg","height":40,"width":40});
;// CONCATENATED MODULE: ./src/assets/images/birthday.svg
/* harmony default export */ var birthday = ({"src":"/_next/static/media/birthday.68a869d1.svg","height":42,"width":42});
// EXTERNAL MODULE: ./src/styles/giftcard.module.scss
var giftcard_module = __webpack_require__(95962);
var giftcard_module_default = /*#__PURE__*/__webpack_require__.n(giftcard_module);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(89936);
// EXTERNAL MODULE: ./src/store/slices/auth.ts
var auth = __webpack_require__(40034);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
// EXTERNAL MODULE: ./src/api/http-client.ts
var http_client = __webpack_require__(55642);
// EXTERNAL MODULE: ./src/utils/regex.ts
var regex = __webpack_require__(1233);
// EXTERNAL MODULE: ./src/api/endpoints.ts
var endpoints = __webpack_require__(3557);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
;// CONCATENATED MODULE: ./src/components/gift-card/swiper/swiper-slide.tsx




var SwiperGiftCard = function(param) {
    var type = param.type, ind = param.ind, list = param.list, swiperValue = param.swiperValue, setswiperValue = param.setswiperValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "slider-gift-main",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                    slidesPerView: 5,
                    watchSlidesProgress: true,
                    spaceBetween: 10,
                    navigation: {
                        nextEl: ".arrow-right" + ind + type,
                        prevEl: ".arrow-left" + ind + type
                    },
                    autoHeight: true,
                    pagination: {
                        clickable: true,
                        dynamicBullets: true
                    },
                    children: [
                        !!(list === null || list === void 0 ? void 0 : list.length) && (list === null || list === void 0 ? void 0 : list.map(function(v, k) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* SwiperSlide */.o5, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        onClick: function() {
                                            setswiperValue({
                                                value: k,
                                                index: ind,
                                                type: type
                                            });
                                        },
                                        style: {
                                            height: 100
                                        },
                                        className: swiperValue === k ? "swiper-gift active" : "swiper-gift ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: v,
                                            alt: "",
                                            layout: "fill",
                                            unoptimized: true
                                        })
                                    }),
                                    " "
                                ]
                            }, k);
                        })),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: (list === null || list === void 0 ? void 0 : list.length) <= 5 ? "d-none" : "" + " arrow-left".concat(ind + type) + " arrow arrow-next",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                fill: "#ff1932",
                                viewBox: "0 0 16 16",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: (list === null || list === void 0 ? void 0 : list.length) <= 5 ? "d-none" : "" + " arrow-right".concat(ind + type) + " arrow arrow-prv",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                fill: "#ff1932",
                                viewBox: "0 0 16 16",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var swiper_slide = (SwiperGiftCard);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-easy-crop/index.module.js + 1 modules
var index_module = __webpack_require__(66703);
;// CONCATENATED MODULE: ./src/components/gift-card/canvasUtils.js


var createImage = function(url) {
    return new Promise(function(resolve, reject) {
        var image = new Image();
        image.addEventListener("load", function() {
            return resolve(image);
        });
        image.addEventListener("error", function(error) {
            return reject(error);
        });
        image.setAttribute("crossOrigin", "anonymous") // needed to avoid cross-origin issues on CodeSandbox
        ;
        image.src = url;
    });
};
function getRadianAngle(degreeValue) {
    return degreeValue * Math.PI / 180;
}
/**
 * Returns the new bounding area of a rotated rectangle.
 */ function rotateSize(width, height, rotation) {
    var rotRad = getRadianAngle(rotation);
    return {
        width: Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
        height: Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height)
    };
}
/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 */ /**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 */ function getCroppedImg(imageSrc, pixelCrop) {
    return _getCroppedImg.apply(this, arguments);
}
function _getCroppedImg() {
    _getCroppedImg = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(imageSrc, pixelCrop) {
        var rotation, flip, image, canvas, ctx, rotRad, ref, bBoxWidth, bBoxHeight, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    rotation = _args.length > 2 && _args[2] !== void 0 ? _args[2] : 0, flip = _args.length > 3 && _args[3] !== void 0 ? _args[3] : {
                        horizontal: false,
                        vertical: false
                    };
                    _ctx.next = 3;
                    return createImage(imageSrc);
                case 3:
                    image = _ctx.sent;
                    canvas = document.createElement("canvas");
                    ctx = canvas.getContext("2d");
                    if (ctx) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 8:
                    rotRad = getRadianAngle(rotation);
                    ref = rotateSize(image.width, image.height, rotation), bBoxWidth = ref.width, bBoxHeight = ref.height;
                    // Set canvas size to the final crop size
                    canvas.width = pixelCrop.width;
                    canvas.height = pixelCrop.height;
                    // Translate context to center of canvas
                    ctx.translate(canvas.width / 2, canvas.height / 2);
                    ctx.rotate(rotRad);
                    ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1);
                    // Draw the image shifted by its center and the crop offset relative to the bounding box center
                    ctx.drawImage(image, -image.width / 2 - (pixelCrop.x - (bBoxWidth - pixelCrop.width) / 2), -image.height / 2 - (pixelCrop.y - (bBoxHeight - pixelCrop.height) / 2));
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        canvas.toBlob(function(blob) {
                            if (!blob) {
                                reject(new Error("Canvas is empty"));
                                return;
                            }
                            var reader = new FileReader();
                            reader.onloadend = function() {
                                resolve({
                                    preview: URL.createObjectURL(blob),
                                    file: reader === null || reader === void 0 ? void 0 : reader.result,
                                    mimeType: blob.type
                                });
                            };
                            reader.readAsDataURL(blob);
                        }, "image/jpeg");
                    }));
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getCroppedImg.apply(this, arguments);
}
function getRotatedImage(imageSrc) {
    return _getRotatedImage.apply(this, arguments);
}
function _getRotatedImage() {
    _getRotatedImage = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(imageSrc) {
        var rotation, image, canvas, ctx, orientationChanged, width, height, MAX_DIMENSION, ratio, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    rotation = _args.length > 1 && _args[1] !== void 0 ? _args[1] : 0;
                    _ctx.next = 3;
                    return createImage(imageSrc);
                case 3:
                    image = _ctx.sent;
                    canvas = document.createElement("canvas");
                    ctx = canvas.getContext("2d");
                    orientationChanged = rotation === 90 || rotation === -90 || rotation === 270 || rotation === -270;
                    width = image.width;
                    height = image.height;
                    MAX_DIMENSION = 2048;
                    if (width > MAX_DIMENSION || height > MAX_DIMENSION) {
                        ratio = Math.min(MAX_DIMENSION / width, MAX_DIMENSION / height);
                        width *= ratio;
                        height *= ratio;
                    }
                    if (orientationChanged) {
                        canvas.width = height;
                        canvas.height = width;
                    } else {
                        canvas.width = width;
                        canvas.height = height;
                    }
                    ctx.translate(canvas.width / 2, canvas.height / 2);
                    ctx.rotate(rotation * Math.PI / 180);
                    ctx.drawImage(image, -width / 2, -height / 2, width, height);
                    return _ctx.abrupt("return", new Promise(function(resolve) {
                        canvas.toBlob(function(file) {
                            resolve(URL.createObjectURL(file));
                        }, "image/jpeg", 0.8); // Using jpeg and 0.8 quality for smaller blob size
                    }));
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getRotatedImage.apply(this, arguments);
}

// EXTERNAL MODULE: ./node_modules/get-orientation/browser.js
var browser = __webpack_require__(44367);
;// CONCATENATED MODULE: ./src/components/gift-card/UploadSection.tsx









 // same as demo

var ORIENTATION_TO_ANGLE = {
    3: 180,
    6: 90,
    8: -90
};
var UploadSection = function(param) {
    var indexFile = param.indexFile, setUploadFile = param.setUploadFile;
    var fileInputRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(""), fileName = ref[0], setFileName = ref[1];
    var ref1 = (0,react.useState)(false), showModal2 = ref1[0], setShowModal2 = ref1[1];
    // cropper states
    var ref2 = (0,react.useState)(null), imageSrc = ref2[0], setImageSrc = ref2[1];
    var ref3 = (0,react.useState)({
        x: 0,
        y: 0
    }), crop = ref3[0], setCrop = ref3[1];
    var ref4 = (0,react.useState)(0), rotation = ref4[0], setRotation = ref4[1];
    var ref5 = (0,react.useState)(1), zoom = ref5[0], setZoom = ref5[1];
    var ref6 = (0,react.useState)(null), croppedAreaPixels = ref6[0], setCroppedAreaPixels = ref6[1];
    var ref7 = (0,react.useState)(null), croppedImage = ref7[0], setCroppedImage = ref7[1];
    var ref8 = (0,react.useState)(null), croppedImg = ref8[0], setCroppedImg = ref8[1];
    var handleClick = function() {
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
            fileInputRef.current.click();
        }
    };
    var onCropComplete = (0,react.useCallback)(function(_, croppedAreaPixels) {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);
    var showCroppedImage = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var croppedImg;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    if (!(!imageSrc || !croppedAreaPixels)) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    _ctx.next = 5;
                    return getCroppedImg(imageSrc, croppedAreaPixels, rotation);
                case 5:
                    croppedImg = _ctx.sent;
                    setCroppedImg((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, croppedImg), {
                        indexFile: indexFile
                    }));
                    setCroppedImage(croppedImg.preview);
                    _ctx.next = 13;
                    break;
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    ;
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    })), [
        imageSrc,
        croppedAreaPixels,
        rotation,
        indexFile
    ]);
    var handleFileChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var file, imageDataUrl, orientation, rotate;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        file = e.target.files[0];
                        if (file) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        setFileName(file.name);
                        _ctx.next = 6;
                        return readFile(file);
                    case 6:
                        imageDataUrl = _ctx.sent;
                        _ctx.prev = 7;
                        _ctx.next = 10;
                        return (0,browser.getOrientation)(file);
                    case 10:
                        orientation = _ctx.sent;
                        rotate = ORIENTATION_TO_ANGLE[orientation];
                        if (!rotate) {
                            _ctx.next = 16;
                            break;
                        }
                        _ctx.next = 15;
                        return getRotatedImage(imageDataUrl, rotate);
                    case 15:
                        imageDataUrl = _ctx.sent;
                    case 16:
                        _ctx.next = 21;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](7);
                        ;
                    case 21:
                        setImageSrc(imageDataUrl);
                        setShowModal2(true);
                        setCroppedImage(null);
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    7,
                    18
                ]
            ]);
        }));
        return function handleFileChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (giftcard_module_default()).uploadWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                onClick: handleClick,
                className: (giftcard_module_default()).uploadBtn,
                children: [
                    "Upload Photo",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (giftcard_module_default()).icon,
                        children: "⬆"
                    })
                ]
            }, indexFile),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "file",
                accept: "image/*",
                ref: fileInputRef,
                onChange: handleFileChange,
                style: {
                    display: "none"
                }
            }, indexFile),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                show: showModal2,
                onHide: function() {
                    return setShowModal2(false);
                },
                centered: true,
                scrollable: true,
                size: "lg",
                className: (giftcard_module_default()).custom_modal_img_prev,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                        closeButton: true,
                        className: (giftcard_module_default()).crop_modal_header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
                        className: "p-4 pt-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-center mb-3 pt-4",
                                style: {
                                    color: "#ff1932",
                                    fontSize: "16px"
                                },
                                children: "Drag the corner or your photo to adjust"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-md-7",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                style: {
                                                    fontWeight: 500,
                                                    marginBottom: "10px",
                                                    display: "block"
                                                },
                                                children: "Image:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    position: "relative",
                                                    width: "100%",
                                                    height: "350px",
                                                    background: "#333"
                                                },
                                                children: imageSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* default */.ZP, {
                                                    image: imageSrc,
                                                    crop: crop,
                                                    rotation: rotation,
                                                    zoom: zoom,
                                                    aspect: 1,
                                                    onCropChange: setCrop,
                                                    onCropComplete: onCropComplete,
                                                    onZoomChange: setZoom
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "d-flex justify-content-between align-items-center mt-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center flex-grow-1 me-4",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                className: "me-3 mb-0 text-muted",
                                                                style: {
                                                                    fontWeight: 500
                                                                },
                                                                children: "Zoom"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "range",
                                                                min: "1",
                                                                max: "3",
                                                                step: "0.1",
                                                                value: zoom,
                                                                onChange: function(e) {
                                                                    return setZoom(parseFloat(e.target.value));
                                                                },
                                                                className: "form-range flex-grow-1",
                                                                style: {
                                                                    accentColor: "#0d6efd"
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        type: "button",
                                                        className: "btn text-white px-4 py-2",
                                                        style: {
                                                            backgroundColor: "#ea00b8",
                                                            borderRadius: "6px",
                                                            fontWeight: 600,
                                                            border: "none"
                                                        },
                                                        onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                                            var croppedImg;
                                                            return runtime_default().wrap(function _callee$(_ctx) {
                                                                while(1)switch(_ctx.prev = _ctx.next){
                                                                    case 0:
                                                                        _ctx.prev = 0;
                                                                        if (!(!imageSrc || !croppedAreaPixels)) {
                                                                            _ctx.next = 3;
                                                                            break;
                                                                        }
                                                                        return _ctx.abrupt("return");
                                                                    case 3:
                                                                        _ctx.next = 5;
                                                                        return getCroppedImg(imageSrc, croppedAreaPixels, rotation);
                                                                    case 5:
                                                                        croppedImg = _ctx.sent;
                                                                        setUploadFile((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, croppedImg), {
                                                                            indexFile: indexFile,
                                                                            preview: croppedImg.preview
                                                                        }));
                                                                        setShowModal2(false);
                                                                        _ctx.next = 13;
                                                                        break;
                                                                    case 10:
                                                                        _ctx.prev = 10;
                                                                        _ctx.t0 = _ctx["catch"](0);
                                                                        ;
                                                                    case 13:
                                                                    case "end":
                                                                        return _ctx.stop();
                                                                }
                                                            }, _callee, null, [
                                                                [
                                                                    0,
                                                                    10
                                                                ]
                                                            ]);
                                                        })),
                                                        children: "Continue"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-md-5 ps-md-4 mt-4 mt-md-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mb-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        style: {
                                                            fontWeight: 500,
                                                            marginBottom: "10px",
                                                            display: "block"
                                                        },
                                                        children: "Preview :"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-muted",
                                                        style: {
                                                            fontSize: "15px"
                                                        },
                                                        children: "No preview yet"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                style: {
                                                    borderColor: "#ddd",
                                                    margin: "20px 0"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                        style: {
                                                            fontSize: "18px",
                                                            color: "#333",
                                                            marginBottom: "15px",
                                                            fontWeight: 400
                                                        },
                                                        children: "Image Guidelines"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        className: "text-muted ps-3",
                                                        style: {
                                                            fontSize: "15px",
                                                            lineHeight: "1.6"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                className: "mb-2",
                                                                children: "Select an image of 550\xd7550 pixels. Or"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                className: "mb-2",
                                                                children: "You can select a picture from Facebook or Instagram profile."
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Crop and save the image"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var gift_card_UploadSection = (UploadSection);
// helper
function readFile(file) {
    return new Promise(function(resolve) {
        var reader = new FileReader();
        reader.addEventListener("load", function() {
            return resolve(reader.result);
        }, false);
        reader.readAsDataURL(file);
    });
}

// EXTERNAL MODULE: ./src/lib/unbxd.ts
var unbxd = __webpack_require__(22236);
;// CONCATENATED MODULE: ./src/pages/gift-card/index.tsx































// import "swiper/swiper.scss";




var loadRazorpayScript = function() {
    return new Promise(function(resolve) {
        var script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.onload = function() {
            return resolve(true);
        };
        script.onerror = function() {
            return resolve(false);
        };
        document.body.appendChild(script);
    });
};
var GiftCard = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,react.useState)([
        "Activated"
    ]), active = ref6[0], setActive = ref6[1];
    var ref7 = (0,react.useState)("Disabled"), selectedActive = ref7[0], setSelectedActive = ref7[1];
    var fileInputRef = (0,react.useRef)(null);
    var ref8 = (0,react.useState)(null), uploadFile = ref8[0], setUploadFile = ref8[1];
    var ref9 = (0,react.useState)(false), showModal2 = ref9[0], setShowModal2 = ref9[1];
    var ref10 = (0,react.useState)(false), show = ref10[0], setShow = ref10[1];
    var ref11 = (0,react.useState)([]), designList = ref11[0], setDesignList = ref11[1];
    var ref12 = (0,react.useState)([]), purposes = ref12[0], setPurposes = ref12[1];
    var ref13 = (0,react.useState)([]), templateList = ref13[0], setTemplateList = ref13[1];
    var ref14 = (0,react.useState)(null), preview = ref14[0], setPreview = ref14[1];
    var ref15 = (0,react.useState)([
        "new"
    ]), sameAs = ref15[0], setSameAs = ref15[1];
    var authState = (0,es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var ref16 = (0,react.useState)(false), loading = ref16[0], setLoading = ref16[1];
    var handleClose = function() {
        return setShow(false);
    };
    var handleShow = function() {
        return setShow(true);
    };
    var dispatch = (0,store/* useAppDispatch */.T)();
    var ref17 = (0,react.useState)(null), thumbsSwiper = ref17[0], setThumbsSwiper = ref17[1];
    var ref18 = (0,react.useState)(0), openCard = ref18[0], setOpenCard = ref18[1];
    var ref19 = (0,react.useState)({
        value: "",
        index: -1,
        type: ""
    }), swiperValue = ref19[0], setSwiperValue = ref19[1];
    (0,react.useEffect)(function() {
        if (uploadFile) {
            var indexFile = uploadFile.indexFile, file = uploadFile.file, mimeType = uploadFile.mimeType, filePreview = uploadFile.preview;
            var newItems = (0,_to_consumable_array/* default */.Z)(formik.values.items);
            newItems[indexFile] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newItems[indexFile]), {
                design_image_file: {
                    file: file,
                    mimeType: mimeType,
                    preview: filePreview
                },
                design_image_url: filePreview
            });
            formik.setFieldValue("items", newItems);
        }
    }, [
        uploadFile
    ]);
    var router = (0,next_router.useRouter)();
    var numberToArray = function(n) {
        return Array.from({
            length: n
        }, function(_, index) {
            return index;
        });
    };
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            items: [
                {
                    purpose: "",
                    // other_purpose: "",
                    amount: "",
                    design_image_url: "",
                    template_image_url: "",
                    name: "",
                    email: "",
                    mobile: "",
                    message: "",
                    show_sender_info: false,
                    card_for_self: false,
                    design_image_file: {
                        file: null,
                        mimeType: "",
                        preview: ""
                    }
                }, 
            ],
            card_no: "",
            image: ""
        },
        validationSchema: yup_es/* object */.Ry().shape({
            items: yup_es/* array */.IX().of(yup_es/* object */.Ry().shape({
                purpose: yup_es/* string */.Z_().required("Please select your purpose"),
                // other_purpose: Yup.string().when("purpose", {
                //   is: (purpose: string) => purpose === "Other",
                //   then: Yup.string().required("Purpose is required"),
                //   otherwise: Yup.string(),
                // }),
                amount: yup_es/* number */.Rx().required("Please enter amount").min(500, "Amount must be within 500-1,00,000").max(100000, "Amount must be within 500-1,00,000").test("is-multiple-of-500", "Amount must be a multiple of 500", function(value) {
                    return value % 500 === 0;
                }),
                design_image_url: yup_es/* string */.Z_().when("$index", function(index, schema) {
                    return active[index] === "Activated" ? schema.required("Please select a template") : schema.notRequired();
                }),
                template_image_url: yup_es/* string */.Z_().when("$index", function(index, schema) {
                    return active[index] === "Activated" ? schema.required("Please select a GIF") : schema.notRequired();
                }),
                name: yup_es/* string */.Z_().required("Name is required"),
                email: yup_es/* string */.Z_().required("Email is required").email("Invalid email format"),
                mobile: yup_es/* string */.Z_().required("Mobile number is required").matches(regex/* phoneRegExp */.O, "Mobile number is not valid").test("len", "Mobile number needs to be exactly 10 digits", function(val) {
                    return (val === null || val === void 0 ? void 0 : val.toString().length) === 10;
                })
            })),
            card_no: yup_es/* string */.Z_().when("items", {
                is: function(items) {
                    var ref;
                    return items.reduce(function(acc, item) {
                        return acc + Number(item.amount);
                    }, 0) > 190000 && !(authState === null || authState === void 0 ? void 0 : (ref = authState.user) === null || ref === void 0 ? void 0 : ref.pan);
                },
                then: yup_es/* string */.Z_().required("Pan card number is required"),
                otherwise: yup_es/* string */.Z_()
            }),
            image: yup_es/* string */.Z_().when("items", {
                is: function(items) {
                    var ref;
                    return items.reduce(function(acc, item) {
                        return acc + Number(item.amount);
                    }, 0) > 190000 && !(authState === null || authState === void 0 ? void 0 : (ref = authState.user) === null || ref === void 0 ? void 0 : ref.pan);
                },
                then: yup_es/* string */.Z_().required("Image is required"),
                otherwise: yup_es/* string */.Z_()
            })
        }),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
                var i, obj, datas, ref, ref1, ref2, formData, data, ref3, ref4, ref5, ref6, ref7, scriptLoaded, options, rzp1, ref8;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (authState.user) {
                                _ctx.next = 3;
                                break;
                            }
                            dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                            return _ctx.abrupt("return");
                        case 3:
                            if (authState.user.billing_address) {
                                _ctx.next = 6;
                                break;
                            }
                            dispatch(auth/* authActions.setBillingModalOpen */.YV.setBillingModalOpen(true));
                            return _ctx.abrupt("return");
                        case 6:
                            i = 0;
                        case 7:
                            if (!(i < values.items.length)) {
                                _ctx.next = 15;
                                break;
                            }
                            obj = values.items[i];
                            if (!(active[i] === "Disabled" && (!obj.design_image_file || !obj.design_image_file.file))) {
                                _ctx.next = 12;
                                break;
                            }
                            react_toastify_esm/* toast.error */.Am.error("Please upload file in Gift Card ".concat(i + 1));
                            return _ctx.abrupt("return");
                        case 12:
                            i++;
                            _ctx.next = 7;
                            break;
                        case 15:
                            setLoading(true);
                            datas = values.items.map(function(obj, index) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, obj), {
                                    design_image_url: active[index] !== "Disabled" ? purposes.find(function(v) {
                                        return v.name == obj.purpose;
                                    }).designs[obj.design_image_url] : null,
                                    template_image_url: active[index] !== "Disabled" ? purposes.find(function(v) {
                                        return v.name == obj.purpose;
                                    }).templates[obj.template_image_url] : null,
                                    design_image_file: active[index] == "Disabled" ? {
                                        file: obj.design_image_file.file,
                                        mimeType: obj.design_image_file.mimeType
                                    } : null
                                });
                            });
                            _ctx.prev = 17;
                            ;
                            if (!(values.items.reduce(function(acc, item) {
                                return acc + Number(item.amount);
                            }, 0) > 190000 && values.card_no)) {
                                _ctx.next = 25;
                                break;
                            }
                            formData = new FormData();
                            formData.append("card_no", values.card_no);
                            formData.append("image", values.image);
                            _ctx.next = 25;
                            return http_client/* default.put */.Z.put(endpoints/* default.auth.update_pancard */.Z.auth.update_pancard(), formData);
                        case 25:
                            _ctx.next = 27;
                            return http_client/* default.post */.Z.post(endpoints/* default.giftCard.purchasev2 */.Z.giftCard.purchasev2(), datas);
                        case 27:
                            data = _ctx.sent.data;
                            // toast(data.message, {
                            //   type: "success",
                            //   toastId: "gift-card-success",
                            // });
                            (0,unbxd/* unbxdCusEngTrackEvent */.$z)("checkout_giftcard", {
                                source: "web",
                                platform: "senco",
                                total_prqt: values.items.length,
                                selling_amount: values.items.reduce(function(acc, item) {
                                    return acc + Number(item.amount);
                                }, 0),
                                discount_amt: 0,
                                amount: values.items.reduce(function(accumulator, currentValue) {
                                    return Number(accumulator) + Number(currentValue.amount);
                                }, 0),
                                user_name: ((ref = authState.user) === null || ref === void 0 ? void 0 : ref.name) || "",
                                user_email: ((ref1 = authState.user) === null || ref1 === void 0 ? void 0 : ref1.email) || "",
                                user_mobile: ((ref2 = authState.user) === null || ref2 === void 0 ? void 0 : ref2.mobile) || "",
                                items: values.items.map(function(item, index) {
                                    return {
                                        prid: "giftcard_".concat(index),
                                        prqt: 1,
                                        product_name: "Gift Card",
                                        category: "Gift Card",
                                        brand: constants/* BRAND_NAME */.R,
                                        amount: Number(item.amount),
                                        discount: 0
                                    };
                                })
                            });
                            if (window.smartech) {
                                ;
                                window.smartech("identify", "".concat("91").concat((ref3 = authState.user) === null || ref3 === void 0 ? void 0 : ref3.mobile));
                                (0,unbxd/* unbxdCusEngTrackUser */.nV)({
                                    "pk^mobile": "".concat("91").concat((ref4 = authState.user) === null || ref4 === void 0 ? void 0 : ref4.mobile),
                                    email: (ref5 = authState.user) === null || ref5 === void 0 ? void 0 : ref5.email,
                                    NAME: (ref6 = authState.user) === null || ref6 === void 0 ? void 0 : ref6.name,
                                    GENDER: (ref7 = authState.user) === null || ref7 === void 0 ? void 0 : ref7.gender,
                                    SENCO_USER: "yes"
                                });
                            }
                            if (!(data && data.params)) {
                                _ctx.next = 41;
                                break;
                            }
                            _ctx.next = 33;
                            return loadRazorpayScript();
                        case 33:
                            scriptLoaded = _ctx.sent;
                            if (!(!scriptLoaded || !window.Razorpay)) {
                                _ctx.next = 37;
                                break;
                            }
                            react_toastify_esm/* toast.error */.Am.error("Razorpay SDK failed to load");
                            return _ctx.abrupt("return");
                        case 37:
                            options = {
                                key: data.params.key,
                                amount: data.params.amount,
                                currency: data.params.currency,
                                name: data.params.name,
                                description: data.params.description,
                                image: data.params.image,
                                order_id: data.params.order_id,
                                callback_url: data.params.callback_url,
                                prefill: {
                                    name: data.params.prefill.name,
                                    email: data.params.prefill.email,
                                    contact: data.params.prefill.contact
                                },
                                notes: data.params.notes,
                                theme: {
                                    color: "#3399cc"
                                },
                                handler: function handler(response) {
                                    // console.log(response);
                                    router.push("/gift-card/status/".concat(data.txnid));
                                },
                                modal: {
                                    ondismiss: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                        return runtime_default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    // router.push(`/gift-card/status/${data.txnid}`);
                                    }))
                                }
                            };
                            if (window.Razorpay) {
                                rzp1 = new window.Razorpay(options);
                                rzp1.open();
                            } else {
                                setLoading(false);
                                (0,react_toastify_esm/* toast */.Am)("Razorpay SDK not available", {
                                    type: "error"
                                });
                            }
                            _ctx.next = 42;
                            break;
                        case 41:
                            {
                                window.location.href = data.redirect;
                            }
                        case 42:
                            _ctx.next = 49;
                            break;
                        case 44:
                            _ctx.prev = 44;
                            _ctx.t0 = _ctx["catch"](17);
                            ;
                            ;
                            if ((ref8 = _ctx.t0.response.data) === null || ref8 === void 0 ? void 0 : ref8.message) {
                                (0,react_toastify_esm/* toast */.Am)(_ctx.t0.response.data.message, {
                                    type: "error",
                                    toastId: "gift-card-error"
                                });
                            } else {
                                (0,react_toastify_esm/* toast */.Am)("Something went wrong! Try again!", {
                                    type: "error",
                                    toastId: "gift-card-error"
                                });
                            }
                        case 49:
                            setLoading(false);
                        case 50:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        17,
                        44
                    ]
                ]);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    var loadPurpose = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        _ctx.next = 4;
                        return http_client/* default.get */.Z.get(endpoints/* default.giftCard.purpose */.Z.giftCard.purpose());
                    case 4:
                        response = _ctx.sent;
                        setPurposes((ref = response.data) === null || ref === void 0 ? void 0 : ref.data);
                        _ctx.next = 10;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function loadPurpose() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        loadPurpose();
    }, []);
    (0,react.useEffect)(function() {
        if (swiperValue.index !== -1) {
            var newItems = (0,_to_consumable_array/* default */.Z)(formik.values.items);
            if (swiperValue.type == "gif") {
                newItems[swiperValue.index] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newItems[swiperValue.index]), {
                    template_image_url: swiperValue.value
                });
            } else {
                newItems[swiperValue.index] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newItems[swiperValue.index]), {
                    design_image_url: swiperValue.value
                });
            }
            formik.setFieldValue("items", newItems);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        swiperValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (giftcard_module_default()).subbanner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: gift_banner/* default */.Z,
                    alt: "Gift Card banner"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container-fluid",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (giftcard_module_default()).subbannermobile,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: giftbannermobile,
                        alt: "Gift Card banner"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (giftcard_module_default()).bggiftmainpage,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (giftcard_module_default()).git_card_fill,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (giftcard_module_default()).heading,
                                children: "Enter Details for Gift Card Purchase"
                            })
                        })
                    }),
                     false && /*#__PURE__*/ 0,
                     true && /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                        onSubmit: formik.handleSubmit,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (giftcard_module_default()).gift_card_main,
                            children: [
                                formik.values.items.map(function(item, index) {
                                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((giftcard_module_default()).container, " ", "container"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (giftcard_module_default()).gift_card_full,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (giftcard_module_default()).gift_card_header,
                                                    onClick: function() {
                                                        return setOpenCard(openCard === index ? -1 : index);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (giftcard_module_default()).header_left,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "bi bi-gift"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    children: [
                                                                        "Gift Card ",
                                                                        index + 1
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (giftcard_module_default()).header_right,
                                                            children: [
                                                                formik.values.items.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "bi bi-trash me-3",
                                                                    onClick: function(e) {
                                                                        e.stopPropagation();
                                                                        var data = formik.values.items.filter(function(_, x) {
                                                                            return x !== index;
                                                                        });
                                                                        setActive(function(prev) {
                                                                            return prev.filter(function(_, i) {
                                                                                return i !== index;
                                                                            });
                                                                        });
                                                                        setOpenCard(0);
                                                                        formik.setFieldValue("items", data);
                                                                    },
                                                                    style: {
                                                                        cursor: "pointer"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "bi ".concat(openCard === index ? "bi-dash" : "bi-plus")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "row",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-12",
                                                        children: openCard == index && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (giftcard_module_default()).gift_card_body,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "row g-lg-5",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "col-lg-6 order-2 order-lg-1",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: (giftcard_module_default()).tabs_container,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                        type: "button",
                                                                                        className: "".concat((giftcard_module_default()).tab, " ").concat(active[index] === "Activated" ? (giftcard_module_default()).active : ""),
                                                                                        onClick: function() {
                                                                                            var select = (0,_to_consumable_array/* default */.Z)(active);
                                                                                            select[index] = "Activated";
                                                                                            setActive(select);
                                                                                            var value = (0,_to_consumable_array/* default */.Z)(formik.values.items);
                                                                                            if (value[index].purpose) {
                                                                                                var purpose = purposes.find(function(p) {
                                                                                                    return p.name === value[index].purpose;
                                                                                                });
                                                                                                if (purpose) {
                                                                                                    value[index].template_image_url = "0";
                                                                                                    value[index].design_image_url = "0";
                                                                                                    setTemplateList(function(prev) {
                                                                                                        var next = (0,_to_consumable_array/* default */.Z)(prev);
                                                                                                        next[index] = purpose.templates;
                                                                                                        return next;
                                                                                                    });
                                                                                                    setDesignList(function(prev) {
                                                                                                        var next = (0,_to_consumable_array/* default */.Z)(prev);
                                                                                                        next[index] = purpose.designs;
                                                                                                        return next;
                                                                                                    });
                                                                                                }
                                                                                            }
                                                                                            formik.setFieldValue("items", value);
                                                                                        },
                                                                                        children: "Template"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                        type: "button",
                                                                                        className: "".concat((giftcard_module_default()).tab, " ").concat(active[index] === "Disabled" ? (giftcard_module_default()).active : ""),
                                                                                        onClick: function() {
                                                                                            var select = (0,_to_consumable_array/* default */.Z)(active);
                                                                                            select[index] = "Disabled";
                                                                                            setActive(select);
                                                                                            var value = (0,_to_consumable_array/* default */.Z)(formik.values.items);
                                                                                            value[index].design_image_url = "";
                                                                                            value[index].template_image_url = "";
                                                                                            formik.setFieldValue("items", value);
                                                                                        },
                                                                                        children: "Personalised"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: (giftcard_module_default()).form_section,
                                                                                children: [
                                                                                    active[index] === "Activated" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: (giftcard_module_default()).purpose_grid,
                                                                                                children: purposes.map(function(p) {
                                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                        className: "".concat((giftcard_module_default()).purpose_item, " ").concat(item.purpose === p.name ? (giftcard_module_default()).active : ""),
                                                                                                        onClick: function() {
                                                                                                            var value = (0,_to_consumable_array/* default */.Z)(formik.values.items);
                                                                                                            value[index].purpose = p.name;
                                                                                                            value[index].template_image_url = "0";
                                                                                                            value[index].design_image_url = "0";
                                                                                                            setTemplateList(function(prev) {
                                                                                                                var next = (0,_to_consumable_array/* default */.Z)(prev);
                                                                                                                next[index] = p.templates;
                                                                                                                return next;
                                                                                                            });
                                                                                                            setDesignList(function(prev) {
                                                                                                                var next = (0,_to_consumable_array/* default */.Z)(prev);
                                                                                                                next[index] = p.designs;
                                                                                                                return next;
                                                                                                            });
                                                                                                            formik.setFieldValue("items", value);
                                                                                                        },
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                                className: "".concat((giftcard_module_default()).icon_box, " ").concat(item.purpose !== p.name ? (giftcard_module_default()).dotted : ""),
                                                                                                                children: [
                                                                                                                    p.name === "Anniversary" && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                                                        src: Anniversary,
                                                                                                                        alt: "Anniversary"
                                                                                                                    }),
                                                                                                                    p.name === "Wedding" && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                                                        src: diamond_ring,
                                                                                                                        alt: "diamond ring"
                                                                                                                    }),
                                                                                                                    p.name === "Birthday" && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                                                        src: birthday,
                                                                                                                        alt: "Birthday"
                                                                                                                    }),
                                                                                                                    p.name !== "Anniversary" && p.name !== "Wedding" && p.name !== "Birthday" && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                                                        src: others,
                                                                                                                        alt: "others"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                children: p.name
                                                                                                            })
                                                                                                        ]
                                                                                                    }, p.name);
                                                                                                })
                                                                                            }),
                                                                                            !!((ref = item.purpose) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                className: "mb-4",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                        className: "mb-3",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                                                className: "fw-bold mb-2 small text-muted ",
                                                                                                                children: "Select Impression"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide, {
                                                                                                                type: "gif",
                                                                                                                ind: index,
                                                                                                                list: templateList[index],
                                                                                                                swiperValue: formik.values.items[index].template_image_url,
                                                                                                                setswiperValue: setSwiperValue
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                                                className: "fw-bold mb-2 small text-muted ",
                                                                                                                children: "Select Template"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide, {
                                                                                                                type: "template",
                                                                                                                ind: index,
                                                                                                                list: designList[index],
                                                                                                                swiperValue: formik.values.items[index].design_image_url,
                                                                                                                setswiperValue: setSwiperValue
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    active[index] === "Disabled" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "mb-5",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: (giftcard_module_default()).section_title_row,
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                    className: (giftcard_module_default()).section_title,
                                                                                                    children: "Upload Personal Image"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(gift_card_UploadSection, {
                                                                                                indexFile: index,
                                                                                                setUploadFile: setUploadFile
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: (giftcard_module_default()).form_group,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                                children: [
                                                                                                    "Enter Amount (₹500 - ₹1,00,000)",
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                                                        children: "*"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                className: (giftcard_module_default()).input_with_icon,
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                                        className: "bi bi-currency-rupee"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                                        type: "number",
                                                                                                        placeholder: "₹"
                                                                                                    }, formik.getFieldProps("items.".concat(index, ".amount"))))
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: (giftcard_module_default()).amount_presets,
                                                                                                children: [
                                                                                                    1000,
                                                                                                    2500,
                                                                                                    5000,
                                                                                                    10000
                                                                                                ].map(function(v) {
                                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                                                        type: "button",
                                                                                                        className: Number(item.amount) === v ? (giftcard_module_default()).active : "",
                                                                                                        onClick: function() {
                                                                                                            var value = (0,_to_consumable_array/* default */.Z)(formik.values.items);
                                                                                                            value[index].amount = String(v);
                                                                                                            formik.setFieldValue("items", value);
                                                                                                        },
                                                                                                        children: [
                                                                                                            "₹",
                                                                                                            v.toLocaleString()
                                                                                                        ]
                                                                                                    }, v);
                                                                                                })
                                                                                            }),
                                                                                            ((ref1 = formik.touched.items) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[index]) === null || ref2 === void 0 ? void 0 : ref2.amount) && ((ref4 = (ref3 = formik.errors.items) === null || ref3 === void 0 ? void 0 : ref3[index]) === null || ref4 === void 0 ? void 0 : ref4.amount) && /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                                className: "text-danger",
                                                                                                children: ((ref5 = formik.errors.items) === null || ref5 === void 0 ? void 0 : ref5[index]).amount
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: (giftcard_module_default()).section_title_row,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: (giftcard_module_default()).section_title,
                                                                                                children: "Receiver Information"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                className: (giftcard_module_default()).buy_for_self_wrap,
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                                        type: "checkbox",
                                                                                                        id: "buyForSelf" + index,
                                                                                                        checked: item.card_for_self,
                                                                                                        onChange: function(e) {
                                                                                                            if (!authState.user) {
                                                                                                                dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                                                                                                                return;
                                                                                                            }
                                                                                                            var value = (0,_to_consumable_array/* default */.Z)(formik.values.items);
                                                                                                            value[index].card_for_self = e.target.checked;
                                                                                                            if (e.target.checked) {
                                                                                                                var ref, ref1, ref2;
                                                                                                                value[index].name = ((ref = authState.user) === null || ref === void 0 ? void 0 : ref.name) || "";
                                                                                                                value[index].email = ((ref1 = authState.user) === null || ref1 === void 0 ? void 0 : ref1.email) || "";
                                                                                                                value[index].mobile = ((ref2 = authState.user) === null || ref2 === void 0 ? void 0 : ref2.mobile) || "";
                                                                                                            } else {
                                                                                                                value[index].name = "";
                                                                                                                value[index].email = "";
                                                                                                                value[index].mobile = "";
                                                                                                            }
                                                                                                            formik.setFieldValue("items", value);
                                                                                                        }
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                                        htmlFor: "buyForSelf" + index,
                                                                                                        children: "Buy for Self"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: (giftcard_module_default()).form_group,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                                children: [
                                                                                                    "Full Name",
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                                                        children: "*"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                                type: "text",
                                                                                                placeholder: "Enter receiver name"
                                                                                            }, formik.getFieldProps("items.".concat(index, ".name")))),
                                                                                            ((ref6 = formik.touched.items) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[index]) === null || ref7 === void 0 ? void 0 : ref7.name) && ((ref9 = (ref8 = formik.errors.items) === null || ref8 === void 0 ? void 0 : ref8[index]) === null || ref9 === void 0 ? void 0 : ref9.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                                className: "text-danger",
                                                                                                children: ((ref10 = formik.errors.items) === null || ref10 === void 0 ? void 0 : ref10[index]).name
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "row",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: "col-md-6",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                    className: (giftcard_module_default()).form_group,
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                                            children: [
                                                                                                                "Email",
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                                                                    children: "*"
                                                                                                                })
                                                                                                            ]
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                                            type: "email",
                                                                                                            placeholder: "Enter email"
                                                                                                        }, formik.getFieldProps("items.".concat(index, ".email")))),
                                                                                                        ((ref11 = formik.touched.items) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[index]) === null || ref12 === void 0 ? void 0 : ref12.email) && ((ref14 = (ref13 = formik.errors.items) === null || ref13 === void 0 ? void 0 : ref13[index]) === null || ref14 === void 0 ? void 0 : ref14.email) && /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                                            className: "text-danger",
                                                                                                            children: ((ref15 = formik.errors.items) === null || ref15 === void 0 ? void 0 : ref15[index]).email
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: "col-md-6",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                    className: (giftcard_module_default()).form_group,
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                                            children: [
                                                                                                                "Phone",
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                                                                    children: "*"
                                                                                                                })
                                                                                                            ]
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                                            type: "text",
                                                                                                            placeholder: "Enter phone"
                                                                                                        }, formik.getFieldProps("items.".concat(index, ".mobile")))),
                                                                                                        ((ref16 = formik.touched.items) === null || ref16 === void 0 ? void 0 : (ref17 = ref16[index]) === null || ref17 === void 0 ? void 0 : ref17.mobile) && ((ref19 = (ref18 = formik.errors.items) === null || ref18 === void 0 ? void 0 : ref18[index]) === null || ref19 === void 0 ? void 0 : ref19.mobile) && /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                                            className: "text-danger",
                                                                                                            children: ((ref20 = formik.errors.items) === null || ref20 === void 0 ? void 0 : ref20[index]).mobile
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: (giftcard_module_default()).form_group,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                                children: "Special Message"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread/* default */.Z)({
                                                                                                rows: 3,
                                                                                                placeholder: "Write your message here",
                                                                                                maxLength: 100
                                                                                            }, formik.getFieldProps("items.".concat(index, ".message")))),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                                                                                className: "float-end text-muted mt-1",
                                                                                                children: [
                                                                                                    ((ref21 = item.message) === null || ref21 === void 0 ? void 0 : ref21.length) || 0,
                                                                                                    "/100"
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "d-flex justify-content-between align-items-center mt-4 w-100",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                className: "form-check custom-checkbox",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                                        className: "form-check-input",
                                                                                                        type: "checkbox",
                                                                                                        id: "senderInfo" + index,
                                                                                                        checked: item.show_sender_info,
                                                                                                        onChange: function(e) {
                                                                                                            if (!authState.user) {
                                                                                                                dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                                                                                                                return;
                                                                                                            }
                                                                                                            var value = (0,_to_consumable_array/* default */.Z)(formik.values.items);
                                                                                                            value[index].show_sender_info = e.target.checked;
                                                                                                            formik.setFieldValue("items", value);
                                                                                                        }
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                                        className: "form-check-label fw-bold small",
                                                                                                        htmlFor: "senderInfo" + index,
                                                                                                        children: "Add Sender Info"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                                type: "button",
                                                                                                className: (giftcard_module_default()).add_more_btn,
                                                                                                onClick: function() {
                                                                                                    if (formik.values.items.length < 5) {
                                                                                                        setActive((0,_to_consumable_array/* default */.Z)(active).concat([
                                                                                                            "Activated"
                                                                                                        ]));
                                                                                                        setOpenCard(formik.values.items.length);
                                                                                                        setSameAs((0,_to_consumable_array/* default */.Z)(sameAs).concat([
                                                                                                            "new"
                                                                                                        ]));
                                                                                                        formik.setFieldValue("items", (0,_to_consumable_array/* default */.Z)(formik.values.items).concat([
                                                                                                            {
                                                                                                                purpose: "",
                                                                                                                amount: "",
                                                                                                                design_image_file: {
                                                                                                                    file: null,
                                                                                                                    mimeType: "",
                                                                                                                    preview: ""
                                                                                                                },
                                                                                                                design_image_url: "",
                                                                                                                template_image_url: "",
                                                                                                                name: "",
                                                                                                                email: "",
                                                                                                                mobile: "",
                                                                                                                message: "",
                                                                                                                show_sender_info: false,
                                                                                                                card_for_self: false
                                                                                                            }, 
                                                                                                        ]));
                                                                                                    }
                                                                                                },
                                                                                                children: "Add More Gift +"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "col-lg-6 order-1 order-lg-2 mb-4 mb-lg-0",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (giftcard_module_default()).preview_container,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "".concat((giftcard_module_default()).description, " ", "mb-3 d-flex align-items-center gap-2  small"),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                            className: "bi bi-cloud-arrow-up"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            children: "Please Upload Preview"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (giftcard_module_default()).preview_card_wrapper,
                                                                                    children: !!((ref22 = String(item.design_image_url)) === null || ref22 === void 0 ? void 0 : ref22.length) && !!String(item.template_image_url).length || !!((ref23 = item.design_image_file) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.preview) === null || ref24 === void 0 ? void 0 : ref24.length) ? active[index] === "Activated" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                                src: ((ref25 = purposes.find(function(v) {
                                                                                                    return v.name == item.purpose;
                                                                                                })) === null || ref25 === void 0 ? void 0 : ref25.designs[item.design_image_url]) || gift_card_bg_premium,
                                                                                                alt: "bg gift",
                                                                                                layout: "fill",
                                                                                                className: (giftcard_module_default()).bg_img_main_img
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                                src: ((ref26 = purposes.find(function(v) {
                                                                                                    return v.name == item.purpose;
                                                                                                })) === null || ref26 === void 0 ? void 0 : ref26.templates[item.template_image_url]) || "",
                                                                                                alt: "impression gift",
                                                                                                layout: "fill",
                                                                                                className: (giftcard_module_default()).bg_img_main_img,
                                                                                                style: {
                                                                                                    zIndex: 1
                                                                                                },
                                                                                                unoptimized: true
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                className: (giftcard_module_default()).gift_bg_overlay,
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                        className: (giftcard_module_default()).premium_ribbon
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                        className: (giftcard_module_default()).preview_content_overlay
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                                src: ((ref27 = item.design_image_file) === null || ref27 === void 0 ? void 0 : ref27.preview) || gift_card_bg_premium,
                                                                                                alt: "personalised preview",
                                                                                                layout: "fill",
                                                                                                className: (giftcard_module_default()).bg_img_main_img
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: (giftcard_module_default()).gift_bg_overlay
                                                                                            })
                                                                                        ]
                                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: (giftcard_module_default()).placeholder_content,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                            src: gift_card_defult,
                                                                                            alt: ""
                                                                                        })
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                                    type: "button",
                                                                                    className: (giftcard_module_default()).preview_text_wrap,
                                                                                    onClick: function() {
                                                                                        if (parseFloat(item.amount) > 0) {
                                                                                            setPreview(item);
                                                                                            setSelectedActive(active[index]);
                                                                                            handleShow();
                                                                                        } else {
                                                                                            react_toastify_esm/* toast.error */.Am.error("Please enter amount");
                                                                                        }
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                            className: "bi bi-eye"
                                                                                        }),
                                                                                        "Preview your Gift Card"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }, index);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((giftcard_module_default()).container, " ", "container"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-lg-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (giftcard_module_default()).order_summary,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (giftcard_module_default()).summary_title,
                                                        children: "Order Summary"
                                                    }),
                                                    formik.values.items.reduce(function(acc, curr) {
                                                        return acc + Number(curr.amount || 0);
                                                    }, 0) > 190000 && !(authState === null || authState === void 0 ? void 0 : (ref = authState.user) === null || ref === void 0 ? void 0 : ref.pan) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "border rounded p-4 bg-white mb-4 shadow-sm",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                className: "fw-bold mb-2 text-danger",
                                                                children: [
                                                                    "PAN Card Information Required ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                                        children: "*"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-muted small mb-3",
                                                                children: "PAN card is required for transactions above ₹1.9 lac as per regulatory requirements."
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "row g-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "col-md-6",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                className: "form-control",
                                                                                type: "text",
                                                                                placeholder: "Enter 10-digit PAN Number"
                                                                            }, formik.getFieldProps("card_no"))),
                                                                            formik.touched.card_no && formik.errors.card_no ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                className: "text-danger",
                                                                                children: formik.errors.card_no
                                                                            }) : null
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "col-md-6",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                type: "file",
                                                                                className: "form-control d-none",
                                                                                accept: "image/*",
                                                                                style: {
                                                                                    display: "none"
                                                                                },
                                                                                onChange: function(event) {
                                                                                    var file = event.currentTarget.files && event.currentTarget.files[0];
                                                                                    if (file) formik.setFieldValue("image", file);
                                                                                }
                                                                            }),
                                                                            formik.touched.image && formik.errors.image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                className: "text-danger",
                                                                                children: formik.errors.image
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (giftcard_module_default()).summary_row,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (giftcard_module_default()).summary_left,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (giftcard_module_default()).summary_item,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (giftcard_module_default()).label,
                                                                                children: "Total Payble Amount"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: (giftcard_module_default()).value,
                                                                                children: [
                                                                                    "₹",
                                                                                    formik.values.items.reduce(function(acc, curr) {
                                                                                        return acc + Number(curr.amount || 0);
                                                                                    }, 0).toLocaleString()
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (giftcard_module_default()).summary_item,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (giftcard_module_default()).label,
                                                                                children: "Total Gift Card"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (giftcard_module_default()).value,
                                                                                children: formik.values.items.length
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                type: "submit",
                                                                className: (giftcard_module_default()).proceed_btn,
                                                                disabled: formik.values.items.reduce(function(acc, curr) {
                                                                    return acc + Number(curr.amount || 0);
                                                                }, 0) <= 0,
                                                                children: "Proceed"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                show: show,
                onHide: handleClose,
                className: (giftcard_module_default()).custom_modal_gift,
                centered: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                        className: (giftcard_module_default()).header_pop,
                        closeButton: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                        className: "p-0",
                        children: preview && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (giftcard_module_default()).modern_preview_container,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (giftcard_module_default()).modern_preview_img_wrapper,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: selectedActive === "Activated" ? ((ref1 = purposes.find(function(v) {
                                                return v.name == (preview === null || preview === void 0 ? void 0 : preview.purpose);
                                            })) === null || ref1 === void 0 ? void 0 : ref1.designs[preview === null || preview === void 0 ? void 0 : preview.design_image_url]) || gift_card_bg_premium : (preview === null || preview === void 0 ? void 0 : (ref2 = preview.design_image_file) === null || ref2 === void 0 ? void 0 : ref2.preview) || gift_card_bg_premium,
                                            alt: "bg gift",
                                            layout: "fill",
                                            objectFit: "cover",
                                            className: (giftcard_module_default()).modern_img
                                        }),
                                        selectedActive === "Activated" && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: ((ref3 = purposes.find(function(v) {
                                                return v.name == (preview === null || preview === void 0 ? void 0 : preview.purpose);
                                            })) === null || ref3 === void 0 ? void 0 : ref3.templates[preview === null || preview === void 0 ? void 0 : preview.template_image_url]) || "",
                                            alt: "impression gift",
                                            layout: "fill",
                                            objectFit: "cover",
                                            className: (giftcard_module_default()).modern_img,
                                            style: {
                                                zIndex: 1
                                            },
                                            unoptimized: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (giftcard_module_default()).modern_preview_content,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (giftcard_module_default()).modern_user_name,
                                            children: preview === null || preview === void 0 ? void 0 : preview.name
                                        }),
                                        !!(preview === null || preview === void 0 ? void 0 : (ref4 = preview.message) === null || ref4 === void 0 ? void 0 : ref4.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (giftcard_module_default()).modern_user_msg,
                                            children: preview === null || preview === void 0 ? void 0 : preview.message
                                        }),
                                        !!(preview === null || preview === void 0 ? void 0 : preview.show_sender_info) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (giftcard_module_default()).modern_sender_info,
                                            children: [
                                                "With Love From: ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: (ref5 = authState.user) === null || ref5 === void 0 ? void 0 : ref5.name
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (giftcard_module_default()).modern_preview_footer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (giftcard_module_default()).modern_amount,
                                            children: [
                                                "Rs. ",
                                                Number((preview === null || preview === void 0 ? void 0 : preview.amount) || 0).toLocaleString()
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (giftcard_module_default()).modern_logo,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: logo_pop_new/* default */.Z,
                                                alt: "logo",
                                                height: 48,
                                                width: 140,
                                                objectFit: "contain"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var gift_card = (GiftCard);


/***/ }),

/***/ 95962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subbanner":"giftcard_subbanner__tld_r","banner_content":"giftcard_banner_content__Z1PuD","banner_left":"giftcard_banner_left__shsBv","banner_right":"giftcard_banner_right__P_zJI","gift_card_text":"giftcard_gift_card_text__khl1u","gift":"giftcard_gift__fGchh","card":"giftcard_card__PHEb6","subbannermobile":"giftcard_subbannermobile__K_xK_","bggiftmainpage":"giftcard_bggiftmainpage__rh93C","git_card_fill":"giftcard_git_card_fill__Iuazg","heading":"giftcard_heading__luzmP","gift_card_main":"giftcard_gift_card_main__7DTgq","gift_card_full":"giftcard_gift_card_full___geX6","gift_card_header":"giftcard_gift_card_header__u2kLb","header_left":"giftcard_header_left__7__T7","header_right":"giftcard_header_right__qOQY_","gift_card_body":"giftcard_gift_card_body__4u844","tabs_container":"giftcard_tabs_container___mUY4","tab":"giftcard_tab__4D1OJ","active":"giftcard_active__8hiR9","purpose_grid":"giftcard_purpose_grid__JPdEG","purpose_item":"giftcard_purpose_item__gV0jf","icon_box":"giftcard_icon_box__wyluN","dotted":"giftcard_dotted__76XNk","form_section":"giftcard_form_section___Wfte","section_title_row":"giftcard_section_title_row__CIynZ","section_title":"giftcard_section_title__fdI_x","buy_for_self_wrap":"giftcard_buy_for_self_wrap__bNbbu","form_group":"giftcard_form_group__AF2V_","input_with_icon":"giftcard_input_with_icon__j0B7w","amount_presets":"giftcard_amount_presets__gjfpj","preview_container":"giftcard_preview_container__FOKiA","description":"giftcard_description__4Q6Ao","preview_card_wrapper":"giftcard_preview_card_wrapper__M29X9","bg_img_main_img":"giftcard_bg_img_main_img__cLjYN","gift_bg_overlay":"giftcard_gift_bg_overlay__7HhNv","premium_ribbon":"giftcard_premium_ribbon__b9NbI","preview_content_overlay":"giftcard_preview_content_overlay__Q7I_Z","premium_text":"giftcard_premium_text__J6O_Z","premium_amount":"giftcard_premium_amount__PZcHF","placeholder_content":"giftcard_placeholder_content__zauuq","preview_text_wrap":"giftcard_preview_text_wrap__zI_Nz","add_more_btn":"giftcard_add_more_btn__viVLL","order_summary":"giftcard_order_summary__n1kWI","summary_title":"giftcard_summary_title__Gxw78","summary_row":"giftcard_summary_row__q0Yfc","summary_left":"giftcard_summary_left__h9qEv","summary_item":"giftcard_summary_item__XqN62","label":"giftcard_label__5WFd8","value":"giftcard_value__snOE5","proceed_btn":"giftcard_proceed_btn__gaXTy","preview":"giftcard_preview__uSaMH","button":"giftcard_button__5N7r_","heading_form":"giftcard_heading_form__IjleQ","payamount":"giftcard_payamount__flsFy","span":"giftcard_span__s3jaI","custom_modal_gift":"giftcard_custom_modal_gift__uWlJy","header_pop":"giftcard_header_pop__22UBY","modern_preview_container":"giftcard_modern_preview_container__FKlJK","modern_preview_img_wrapper":"giftcard_modern_preview_img_wrapper__qtF9H","modern_img":"giftcard_modern_img__YlysQ","modern_preview_content":"giftcard_modern_preview_content__9CjGU","modern_user_name":"giftcard_modern_user_name__DzOXl","modern_user_msg":"giftcard_modern_user_msg__7D6nc","modern_sender_info":"giftcard_modern_sender_info__CtWvY","modern_preview_footer":"giftcard_modern_preview_footer__Q0QxH","modern_amount":"giftcard_modern_amount__lJfdm","modern_logo":"giftcard_modern_logo___MUAf","slider_main":"giftcard_slider_main__aCyCl","waviy":"giftcard_waviy__znwnt","uploadWrapper":"giftcard_uploadWrapper____ibO","uploadBtn":"giftcard_uploadBtn__IjmGk","custom_modal_img_prev":"giftcard_custom_modal_img_prev__459L7","crop_modal_header":"giftcard_crop_modal_header__bGk5e","continueBtn":"giftcard_continueBtn__InwpZ","container":"giftcard_container__93TJH","slideDownFade":"giftcard_slideDownFade__6CFYN","fadeIn":"giftcard_fadeIn__g7lOX"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8523,4766,5675,9915,2640,3913,536,486,4972,6646,1251,8524,9774,2888,179], function() { return __webpack_exec__(12824); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);